interface IMakeIsErknmInn {
  errorMessage: string;
  getIsFiz?: () => boolean | undefined;
  getException?: () => boolean;
  getIsRequired?: () => boolean;
}

export function makeIsErknmInn({ errorMessage, getIsFiz, getException, getIsRequired }: IMakeIsErknmInn) {
  return (value?: string) => {
    const isException = getException && getException();
    const isRequired = getIsRequired && getIsRequired();

    if (isException) {
      return undefined;
    }
    let isCorrect = false;

    if (value) {
      const [firstNumber, secondNumber] = value.split('');

      if (getIsFiz) {
        const isFiz = getIsFiz();

        isCorrect =
          (!isFiz && (/^[\d+]{10}$/.test(value) || /^[\d+]{12}$/.test(value))) ||
          (!!isFiz && /^[\d+]{12}$/.test(value));
      } else {
        isCorrect = /^[\d+]{10}$/.test(value) || /^[\d+]{12}$/.test(value);
      }

      if (Number(firstNumber) === 0 && firstNumber === secondNumber) {
        isCorrect = false;
      }
    }
    if (!isRequired && !value) {
      isCorrect = true;
    }

    return isCorrect ? undefined : errorMessage;
  };
}
